import { validationTypes } from "../../../components/finalForms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../../components/finalForms/libs/data/formFieldType";
import { GridColumnType } from "../../../data/gridColumnType";

const initState = {
  statusCategoryName: "",
  isActive: true,
  sortOrder: "",
  isTerminal: false,
  isCompleted: false,
};

export const statusCategoryFormData = {
  name: "Status Category Form",
  initialState: initState,
  section: [
    {
      sectionId: "StatusCategory",
      title: "Status Category",
      row: {},
      style: {
        sectionStyle: "row",
      },
      wrappperTemplate: <div className="form-card row"></div>,
      fields: [
        {
          id: "statusCategoryName",
          label: "Status Category Name",
          Field_Name: "status category",
          fieldType: FormFieldTypes.INPUT,
          dataField: "statusCategoryName",
          fieldSetting: {
            placeholder: "Please Enter Status Category",
            allowSpace: true,
            maxLength: 100,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-12 col-md-12 mb-1 validation-left-0",
          },
        },
        {
          id: "sortOrder",
          label: "Sort Order",
          Field_Name: "sort order",
          fieldType: FormFieldTypes.INPUT,
          dataField: "sortOrder",
          fieldSetting: {
            placeholder: "Optional sort order",
            allowSpace: false,
            maxLength: 5,
          },
          style: {
            containerCss: "col-lg-12 col-md-12 mb-1 validation-left-0",
          },
        },
        {
          id: "isActive",
          label: "Is Active",
          Field_Name: "isactive",
          fieldType: FormFieldTypes.CHECKBOX,
          dataField: "isActive",
          fieldSetting: {
            allowSpace: true,
          },
          style: {
            containerCss: "col-lg-4 col-md-4 col-4 validation-left-0",
          },
        },
        {
          id: "isTerminal",
          label: "Is Terminal",
          Field_Name: "isterminal",
          fieldType: FormFieldTypes.CHECKBOX,
          dataField: "isTerminal",
          fieldSetting: {
            allowSpace: true,
          },
          style: {
            containerCss: "col-lg-4 col-md-4 col-4 validation-left-0",
          },
        },
        {
          id: "isCompleted",
          label: "Is Completed",
          Field_Name: "iscompleted",
          fieldType: FormFieldTypes.CHECKBOX,
          dataField: "isCompleted",
          fieldSetting: {
            allowSpace: true,
          },
          style: {
            containerCss: "col-lg-4 col-md-4 col-4 validation-left-0",
          },
        },
      ],
    },
  ],
};

export const StatusCategoriesGridConfig = {
  columns: [
    {
      name: "Status Category",
      fieldName: "statusCategoryName",
      allowShort: false,
      colStyle: {
        width: "28%",
        textAlign: "center",
      },
    },
    {
      name: "System Default",
      colType: GridColumnType.CHECKBOX,
      fieldName: "isSystemDefault",
      allowShort: false,
      colStyle: {
        width: "14%",
        textAlign: "center",
      },
      colSettings: {
        isDisabled: true,
      },
    },
    {
      name: "Is Active",
      colType: GridColumnType.CHECKBOX,
      fieldName: "isActive",
      allowShort: false,
      colStyle: {
        width: "12%",
        textAlign: "center",
      },
      colSettings: {
        isDisabled: true,
      },
    },
    {
      name: "Terminal",
      colType: GridColumnType.CHECKBOX,
      fieldName: "isTerminal",
      allowShort: false,
      colStyle: {
        width: "12%",
        textAlign: "center",
      },
      colSettings: {
        isDisabled: true,
      },
    },
    {
      name: "Completed",
      colType: GridColumnType.CHECKBOX,
      fieldName: "isCompleted",
      allowShort: false,
      colStyle: {
        width: "12%",
        textAlign: "center",
      },
      colSettings: {
        isDisabled: true,
      },
    },
    {
      name: "Sort Order",
      fieldName: "sortOrder",
      allowShort: false,
      colStyle: {
        width: "10%",
        textAlign: "center",
      },
    },
    {
      name: "Action",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: true,
        allowDelete: (rowData) => !rowData?.isSystemDefault,
      },
      colStyle: {
        width: "12%",
        textAlign: "center",
      },
    },
  ],
};
